module.exports = __webpack_public_path__ + "static/tracy-a780168634452930b8c1b2d4653663fc.jpg";